import { mockSubUsersData } from "./wlDemoData";

const countryCodes = ['AFG', 'ALB', 'DZA', 'ASM', 'AND', 'AGO', 'AIA', 'ATA', 'ATG', 'ARG', 'ARM', 'ABW', 'AUS', 'AUT', 'AZE', 'BHS', 'BHR', 'BGD', 'BRB', 'BLR', 'BEL', 'BLZ', 'BEN', 'BMU', 'BTN', 'BOL', 'BES', 'BIH', 'BWA', 'BVT', 'BRA', 'IOT', 'BRN', 'BGR', 'BFA', 'BDI', 'CPV', 'KHM', 'CMR', 'CAN', 'CYM', 'CAF', 'TCD', 'CHL', 'CHN', 'CXR', 'CCK', 'COL', 'COM', 'COD', 'COG', 'COK', 'CRI', 'HRV', 'CUB', 'CUW', 'CYP', 'CZE', 'CIV', 'DNK', 'DJI', 'DMA', 'DOM', 'ECU', 'EGY', 'SLV', 'GNQ', 'ERI', 'EST', 'SWZ', 'ETH', 'FLK', 'FRO', 'FJI', 'FIN', 'FRA', 'GUF', 'PYF', 'ATF', 'GAB', 'GMB', 'GEO', 'DEU', 'GHA', 'GIB', 'GRC', 'GRL', 'GRD', 'GLP', 'GUM', 'GTM', 'GGY', 'GIN', 'GNB', 'GUY', 'HTI', 'HMD', 'VAT', 'HND', 'HKG', 'HUN', 'ISL', 'IND', 'IDN', 'IRN', 'IRQ', 'IRL', 'IMN', 'ISR', 'ITA', 'JAM', 'JPN', 'JEY', 'JOR', 'KAZ', 'KEN', 'KIR', 'PRK', 'KOR', 'KWT', 'KGZ', 'LAO', 'LVA', 'LBN', 'LSO', 'LBR', 'LBY', 'LIE', 'LTU', 'LUX', 'MAC', 'MDG', 'MWI', 'MYS', 'MDV', 'MLI', 'MLT', 'MHL', 'MTQ', 'MRT', 'MUS', 'MYT', 'MEX', 'FSM', 'MDA', 'MCO', 'MNG', 'MNE', 'MSR', 'MAR', 'MOZ', 'MMR', 'NAM', 'NRU', 'NPL', 'NLD', 'NCL', 'NZL', 'NIC', 'NER', 'NGA', 'NIU', 'NFK', 'MNP', 'NOR', 'OMN', 'PAK', 'PLW', 'PSE', 'PAN', 'PNG', 'PRY', 'PER', 'PHL', 'PCN', 'POL', 'PRT', 'PRI', 'QAT', 'MKD', 'ROU', 'RUS', 'RWA', 'REU', 'BLM', 'SHN', 'KNA', 'LCA', 'MAF', 'SPM', 'VCT', 'WSM', 'SMR', 'STP', 'SAU', 'SEN', 'SRB', 'SYC', 'SLE', 'SGP', 'SXM', 'SVK', 'SVN', 'SLB', 'SOM', 'ZAF', 'SGS', 'SSD', 'ESP', 'LKA', 'SDN', 'SUR', 'SJM', 'SWE', 'CHE', 'SYR', 'TWN', 'TJK', 'TZA', 'THA', 'TLS', 'TGO', 'TKL', 'TON', 'TTO', 'TUN', 'TUR', 'TKM', 'TCA', 'TUV', 'UGA', 'UKR', 'ARE', 'GBR', 'UMI', 'USA', 'URY', 'UZB', 'VUT', 'VEN', 'VNM', 'VGB', 'VIR', 'WLF', 'ESH', 'YEM', 'ZMB', 'ZWE', 'ALA'];

const STORES_PERCENTAGES = {
    spotify: 30,
    youtube: 15,
    apple_music: 12,
    amazon_music: 9,
    youtube_premium: 7,
    soundcloud: 5,
    deezer: 4,
    beatport: 4,
    facebook: 4,
    instagram: 4,
    tiktok: 2,
    pandora: 2,
    traxsource: 1,
    itunes: 1,
};

const TRENDS_STORE_ID_TO_KEY = {
    am: "amazon_music",
    apm: "apple_music",
    bp: "beatport",
    dr: "deezer",
    fb: "facebook",
    ig: "instagram",
    it: "itunes",
    pd: "pandora",
    sc: "soundcloud",
    sp: "spotify",
    tx: "traxsource",
    tk: "tiktok",
    yt: "youtube",
    yp: "youtube_premium",
};

const DOWNLOAD_STORE_KEYS = ["beatport", "itunes", "traxsource"];
const STREAM_STORE_KEYS = Object.keys(STORES_PERCENTAGES).filter(key => !DOWNLOAD_STORE_KEYS.includes(key));

const TOP_TRACKS_TEMPLATE = [
    { song_name: "Eternal Echoes", artist_name: "Elena Harmonix" },
    { song_name: "Midnight Symphony", artist_name: "Alex Rythmo, Luna Spectre" },
    { song_name: "Dancing Shadows", artist_name: "Mia Melodia, Nico Cadence" },
    { song_name: "Whispering Winds", artist_name: "Leo Forte" },
    { song_name: "Stellar Dreams", artist_name: "Iris Fugue" },
    { song_name: "Harmony of Light", artist_name: "Cora Hymn" },
    { song_name: "Rising Melodies", artist_name: "Elena Harmonix" },
    { song_name: "Serene Night", artist_name: "Alex Rythmo" },
    { song_name: "Morning Star", artist_name: "Mia Melodia" },
    { song_name: "Echoes of Time", artist_name: "Nico Cadence" },
];

const hashFilterValue = value => {
    const text = String(value ?? "");
    let hash = 0;
    for (let i = 0; i < text.length; i += 1) {
        hash = ((hash << 5) - hash) + text.charCodeAt(i);
        hash |= 0;
    }
    return Math.abs(hash);
};

const isActiveFilter = value => value != null && String(value) !== "0";

const createSeededRandom = seed => {
    let state = (hashFilterValue(seed) % 233280) + 1;
    return () => {
        state = (state * 9301 + 49297) % 233280;
        return state / 233280;
    };
};

const normalizeToSum = (values, targetSum) => {
    if (!values.length) {
        return [];
    }
    const safeTarget = Math.round(Number(targetSum) || 0);
    const weights = values.map(value => Math.max(0, Number(value) || 0));
    const weightSum = weights.reduce((sum, value) => sum + value, 0) || 1;
    const scaled = weights.map(weight => (weight / weightSum) * safeTarget);
    const rounded = scaled.slice(0, -1).map(value => Math.round(value));
    const partial = rounded.reduce((sum, value) => sum + value, 0);
    rounded.push(safeTarget - partial);
    return rounded;
};

const resolveActiveStoreKeys = storeFilter => {
    const store = String(storeFilter ?? "0");
    if (store === "0") {
        return Object.keys(STORES_PERCENTAGES);
    }
    if (store === "ds") {
        return DOWNLOAD_STORE_KEYS;
    }
    if (store === "ss") {
        return STREAM_STORE_KEYS;
    }
    const mapped = TRENDS_STORE_ID_TO_KEY[store];
    return mapped ? [mapped] : Object.keys(STORES_PERCENTAGES);
};

const resolveFilterScale = (filters = {}) => {
    let scale = 1;
    if (isActiveFilter(filters.subuser)) {
        scale *= 0.45 + (hashFilterValue(filters.subuser) % 45) / 100;
    }
    if (isActiveFilter(filters.label)) {
        scale *= 0.55 + (hashFilterValue(filters.label) % 35) / 100;
    }
    if (isActiveFilter(filters.release)) {
        scale *= 0.35 + (hashFilterValue(filters.release) % 30) / 100;
    }
    if (isActiveFilter(filters.track)) {
        scale *= 0.25 + (hashFilterValue(filters.track) % 25) / 100;
    }
    if (isActiveFilter(filters.store)) {
        const activeKeys = resolveActiveStoreKeys(filters.store);
        const activeWeight = activeKeys.reduce((sum, key) => sum + (STORES_PERCENTAGES[key] ?? 0), 0);
        const totalWeight = Object.values(STORES_PERCENTAGES).reduce((sum, weight) => sum + weight, 0) || 1;
        scale *= Math.max(0.15, activeWeight / totalWeight);
    }
    return scale;
};

const buildTrendsSeed = (numberOfDays, filters = {}) => [
    numberOfDays,
    filters.period || "1",
    filters.store || "0",
    filters.label || "0",
    filters.release || "0",
    filters.track || "0",
    filters.subuser || "0",
].join("|");

const buildTotalSales = (numberOfDays, filters, random) => {
    const base = 70000 + random() * 180000;
    const periodScale = numberOfDays / 7;
    return Math.round(base * periodScale * resolveFilterScale(filters));
};

const buildCountrySales = (totalSales, random) => {
    const selectedCountries = new Set();
    while (selectedCountries.size < 50) {
        selectedCountries.add(countryCodes[Math.floor(random() * countryCodes.length)]);
    }
    const countryArray = Array.from(selectedCountries);
    const countryWeights = countryArray.map(() => 0.2 + random());
    const countryValues = normalizeToSum(countryWeights, totalSales);

    return {
        sales: countryArray.map((code, index) => ({ id: code, value: countryValues[index] })),
        max: Math.max(...countryValues, 0),
    };
};

const buildTopTracks = (totalSales, random) => {
    const tracks = TOP_TRACKS_TEMPLATE.map(track => ({ ...track }));
    const trackWeights = tracks.map(() => 0.4 + random());
    const trackSales = normalizeToSum(trackWeights, totalSales);

    tracks.forEach((track, index) => {
        track.number_of_sales = trackSales[index];
    });

    return tracks.sort((a, b) => b.number_of_sales - a.number_of_sales);
};

const buildMultiSalesGraphData = (numberOfDays, totalSales, activeStoreKeys, random) => {
    const selectedKeys = activeStoreKeys.length ? activeStoreKeys : Object.keys(STORES_PERCENTAGES);
    const storeWeights = selectedKeys.map(key => STORES_PERCENTAGES[key] ?? 1);
    const storeTotals = normalizeToSum(storeWeights, totalSales);
    const storeData = {};

    selectedKeys.forEach((key, index) => {
        const dayWeights = Array.from({ length: numberOfDays }, () => 0.5 + random());
        storeData[key] = { data: normalizeToSum(dayWeights, storeTotals[index]) };
    });

    const combinedSalesData = Array.from({ length: numberOfDays }, (_, dayIndex) =>
        selectedKeys.reduce((sum, key) => sum + storeData[key].data[dayIndex], 0),
    );

    const currentDate = new Date();
    const labels = [];
    for (let i = 0; i < numberOfDays; i += 1) {
        const date = new Date(currentDate);
        date.setDate(date.getDate() - i);
        labels.unshift(date.toISOString().split("T")[0]);
    }

    return {
        labels,
        store_sales: storeData,
        combined_sales: { data: combinedSalesData },
    };
};

const buildGenderAndAgeGraphData = (totalSales, random) => {
    const genderCategories = ["Male", "Female", "Non_binary", "Unknown"];
    const genderKeys = ["male", "female", "gender_other", "unknown"];
    const genderWeights = genderCategories.map(() => 0.4 + random());
    const genderTotals = normalizeToSum(genderWeights, totalSales);

    const ageGroups = ["0-17", "18-22", "23-27", "28-34", "35-44", "45-59", "60-150", "unknown"];
    const ageData = {
        male: [],
        female: [],
        gender_other: [],
        unknown: [],
    };

    genderTotals.forEach((genderTotal, genderIndex) => {
        const genderKey = genderKeys[genderIndex];
        const perAgeWeights = ageGroups.map(() => 0.2 + random());
        ageData[genderKey] = normalizeToSum(perAgeWeights, genderTotal);
    });

    return {
        gender_graph_data: {
            labels: genderCategories,
            data: genderTotals,
        },
        age_graph_data: {
            labels: ageGroups,
            data: ageData,
        },
    };
};

const buildSubUsers = () => mockSubUsersData
    .filter(subUser => subUser.is_active)
    .map(subUser => ({
        id: subUser.id,
        name: subUser.friendly_name || subUser.username,
    }));

const simulateMockTrendsData = (numberOfDays, filters = {}) => {
    const random = createSeededRandom(buildTrendsSeed(numberOfDays, filters));
    const totalSales = buildTotalSales(numberOfDays, filters, random);
    const activeStoreKeys = resolveActiveStoreKeys(filters.store);
    const { gender_graph_data, age_graph_data } = buildGenderAndAgeGraphData(totalSales, random);

    return {
        country_wise_sales: buildCountrySales(totalSales, random),
        top_10_tracks: buildTopTracks(totalSales, random),
        multi_sales_graph_data: buildMultiSalesGraphData(numberOfDays, totalSales, activeStoreKeys, random),
        gender_graph_data,
        age_graph_data,
        sub_users: buildSubUsers(),
        total_sales: totalSales,
    };
};

export default simulateMockTrendsData;
